import Close from '@material-ui/icons/Close';
import { Input } from 'antd';
import styled from 'styled-components';
import getInstance from '../../../request';
import { useDebounce, ProfileURLs, StyledCheckCircleTwoTone } from '../index.util';
import { useEffect, useRef, useState } from 'react';
import { SyncOutlined } from '@ant-design/icons';

const Wrapper = styled.div`
  width: 600px;
`;
const Header = styled.div`
  display: flex;
  height: 55px;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  position: relative;
`;

const Content = styled.div`
  margin-top: 47px;
  display: flex;
  flex-direction: column;
  padding-left: 75px;
  padding-right: 75px;
  margin-bottom: 90px;
`;

const InputContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  & .url-icon {
    margin-right: 12px;
    width: 32px;
  }
  & .ant-input {
    height: 40px;
    border-radius: 4px;
    margin-right: 8px;
  }
  margin-bottom: 12px;
`;


const Title = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #1D1E2B;
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  transform: translateY(50%);
`;

type ModalProps = {
  onClose: () => void;
  urlsDefault: ProfileURLs;
}

export const EditURLsModal = ({ onClose, urlsDefault }: ModalProps): JSX.Element => {
  const [urls, setURLs] = useState<ProfileURLs>(urlsDefault);
  const [loading, setLoading] = useState(false);
  const firstTimeLoad = useRef(true);
  const debouncedValueUrls = useDebounce<ProfileURLs>(urls, 500);
  const [editingUrl, setEditingUrl] = useState('');
  useEffect(() => {
    async function updateURLs() {
      const dataProvider = await getInstance();
      const { id, ...rest } = debouncedValueUrls;
      const method = id ? 'put' : 'post';
      const restURL = `/usersProfiles${id ? `/${id}` : ''}`;
      try {
        const { data: result } = await dataProvider[method](restURL, id ? urls : rest);
        if (result?.data) {
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
    if (firstTimeLoad.current) {
      firstTimeLoad.current = false;
      return;
    } else {
      updateURLs();
    }
  }, [debouncedValueUrls]);
  const onURLsChange = (value: string, linkKey: string) => {
    setLoading(true);
    setEditingUrl(linkKey);
    setURLs(urls => ({
      ...urls,
      [linkKey]: value,
    }))
  }
  const displayFormat = {
    linkedin: 'LinkedIn',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    homepage: 'homepage',
    portfolio: 'portfolio',
  }
  return <Wrapper>
    <Header>
      <Close
        onClick={onClose}
        style={{
          marginRight: '22px',
          color: '#73747D',
          cursor: 'pointer',
        }}
      />
      <Title>URLs</Title>
    </Header>
    <Content>
      {['linkedin', 'instagram', 'tiktok'].map((linkKey) => (
        <InputContent key={linkKey}>
          <img className='url-icon' src={`/img/profile/logo_${linkKey}.svg`} alt={`${linkKey} logo`} />
          <Input defaultValue={urls[linkKey as keyof typeof urls]} placeholder={`Add your ${displayFormat[linkKey as keyof typeof displayFormat]} Account`} onChange={(e) => onURLsChange(e.target.value, linkKey)} />
          {editingUrl === linkKey && loading ?
            <SyncOutlined
              spin
              style={{
                color: '#faad14',
                width: '20px',
              }}
            />
            : <StyledCheckCircleTwoTone twoToneColor="#52c41a" />}
        </InputContent>
      ))}
      {['homepage', 'portfolio'].map((linkKey) => (
        <InputContent key={linkKey}>
          <img className='url-icon' src={`/img/profile/logo_${linkKey}.svg`} alt={`${linkKey} logo`} />
          <Input.TextArea autoSize={{ minRows: 1, maxRows: 6 }} defaultValue={urls[linkKey as keyof typeof urls]} placeholder={`Add your ${displayFormat[linkKey as keyof typeof displayFormat]} Account`} onChange={(e) => onURLsChange(e.target.value, linkKey)} />
          {editingUrl === linkKey && loading ?
            <SyncOutlined
              spin
              style={{
                color: '#faad14',
                width: '20px',
              }}
            />
            : <StyledCheckCircleTwoTone twoToneColor="#52c41a" />}
        </InputContent>
      ))}
    </Content>
  </Wrapper>;
}